import { callApi } from './api'
import { RECURRENCE } from './schemas'

export function fetch (userId, recurrenceId) {
  const endpoint = `users/${userId}/recurrences/${recurrenceId}`
  const config = {
    method: 'GET',
    requiresAuth: true
  }

  return callApi(endpoint, config, RECURRENCE)
}

export function update (userId, recurrenceId, body = {}) {
  if (!recurrenceId) {
    return Promise.reject({
      error: 'Call to PUT recurrences requires an recurrenceId.'
    })
  }

  const endpoint = `users/${userId}/recurrences/${recurrenceId}`
  const config = {
    method: 'PUT',
    body,
    requiresAuth: true
  }

  return callApi(endpoint, config, RECURRENCE)
}

export function cancel (userId, recurrenceId) {
  const endpoint = `users/${userId}/recurrences/${recurrenceId}/cancel`
  const config = {
    method: 'PUT',
    requiresAuth: true
  }

  return callApi(endpoint, config)
}

export function fetchPenalty (userId, recurrenceId, recurrenceChange, method) {
  const endpoint = `users/${userId}/recurrences/${recurrenceId}/penalty`
  const config = {
    method,
    requiresAuth: true
  }

  if (recurrenceChange) {
    config.body = recurrenceChange
  }

  return callApi(endpoint, config)
}



// WEBPACK FOOTER //
// ./src/services/api/recurrences.js